
(() => {
  if (customElements.get('rorilio-brow-bundle')) return;
  class RorilioBrowBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.root = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
      this.addEventListener('change', e => {
        if (e.target.matches('.rb-swatches input')) this.querySelectorAll('[data-tone="1"]').forEach(s => s.value = e.target.value);
        if (e.target.matches('[data-tone="1"]')) {
          this.querySelectorAll('[data-tone="1"]').forEach(s => s.value = e.target.value);
          const radio = [...this.querySelectorAll('.rb-swatches input')].find(x => x.value === e.target.value);
          if (radio) radio.checked = true;
        }
        this.update();
      });
      this.querySelectorAll('[data-pack]').forEach(card => card.addEventListener('click', e => {
        if (e.target.closest('select')) return;
        card.querySelector('input[type="radio"]').checked = true; this.update();
      }));
      this.update();
    }
    update() {
      const pack = this.querySelector('.rb-packs input:checked').value;
      const tone1 = this.querySelector('.rb-swatches input:checked').value;
      const active = [...this.querySelectorAll('[data-pack]')].find(card => card.dataset.pack === pack);
      const tones = [...active.querySelectorAll('select[data-tone]')].sort((a, b) => a.dataset.tone - b.dataset.tone).map(s => s.value);
      const tone2 = tones[1] || 'Sin segundo tubo';
      // Carte 2+1 de la page B (data-units) : le bouton porte le tube « 1 tubo » du 1er ton, l'ajout des 3 tubes est fait par le snippet.
      const units = active.dataset.units;
      const variant = units ? this.variants.find(v => v.options[0] === '1 tubo' && v.options[1] === tone1) : this.variants.find(v => v.options[0] === pack && v.options[1] === tone1 && v.options[2] === tone2);
      this.querySelectorAll('[data-pack]').forEach(card => {
        const selected = card.dataset.pack === pack;
        card.classList.toggle('is-selected', selected);
        card.querySelectorAll('select').forEach(s => s.disabled = !selected);
        const priceVariant = this.variants.find(v => v.options[0] === card.dataset.pack && v.options[1] === tone1);
        if (priceVariant && !card.dataset.units) { card.querySelector('[data-pack-price]').textContent = priceVariant.price; const c = card.querySelector('[data-pack-compare]'); if (c) c.textContent = priceVariant.compare; }
      });
      this.querySelector('[data-selected-shade]').textContent = tone1;
      this.querySelector('[data-selection-note]').textContent = `Tu selección: ${(tones.length ? tones : [tone1]).join(' + ')}`;
      this.root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {input.value = variant?.id || ''; input.disabled = !variant; input.dispatchEvent(new Event('change',{bubbles:true}));});
      const submit = this.root.querySelector('button[name="add"]');
      if (submit) { submit.disabled = !variant?.available; submit.querySelector('span').textContent = variant?.available ? 'AGREGAR AL CARRITO' : 'NO DISPONIBLE'; }
      if (variant) { const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url); }
      if (this.lastTone && this.lastTone !== tone1) {
        const gallery = this.root.querySelector('media-gallery');
        const image = gallery?.querySelector('img[alt="Tinte de cejas Rorilio tono '+tone1+'"]');
        const media = image?.closest('[data-media-id]');
        if (media && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(media.dataset.mediaId, false);
      }
      this.lastTone = tone1;
      document.dispatchEvent(new CustomEvent('rorilio:variant',{detail:variant}));
    }
  }
  customElements.define('rorilio-brow-bundle', RorilioBrowBundle);
})();
